import { createSlice, PayloadAction, SliceCaseReducers } from "@reduxjs/toolkit";

export interface State {
  locationSettings: boolean;
  userTrackingSettings: boolean;
  queue: boolean;
  signout: boolean;
  availability: boolean;
  autoSyncDocuments: boolean;
  editMachineLocation: boolean;
  editMachineProperties: boolean;
  editMachineInstallDate: boolean;
}

interface Reducers extends SliceCaseReducers<State> {
  setOpen: (
    state: State,
    action: PayloadAction<{
      dialogName: Extract<keyof State, string>;
      open: boolean;
    }>
  ) => State;
}

export const initialState: State = {
  locationSettings: false,
  userTrackingSettings: false,
  queue: false,
  signout: false,
  availability: false,
  autoSyncDocuments: false,
  editMachineLocation: false,
  editMachineProperties: false,
  editMachineInstallDate: false,
};
const reducers: Reducers = {
  setOpen: (state, { payload: { dialogName, open } }) => {
    state = { ...initialState };
    state[dialogName] = open;
    return state;
  },
};

const dialogStore = createSlice<State, Reducers>({
  name: "dialog",
  initialState,
  reducers,
});

export default dialogStore.reducer;
export const { setOpen } = dialogStore.actions;
